import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks'
import { toggleScreenCollapse } from '../../../../../redux/reducers/formState/formStateFeature'
import { Section } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import styles from './AdditionalInformationCta.module.css'

import { FlowElementProps } from '../../../../../@types/flow-types'

type AdditionalInformationCtaProps = {
  flowInformation?: FlowElementProps['flowInformation']
  flowName?: FlowElementProps['flowName']
  showMandatoryHint?: boolean
}

export const AdditionalInformationCta: React.FC<AdditionalInformationCtaProps> = () => {
  const { t } = useTranslation()

  const dispatch = useAppDispatch()
  const isCollapsed = useAppSelector((state) => state.formStateFeature.collapsedScreens['objectDetails'] ?? false)

  const handleChange = () => {
    dispatch(toggleScreenCollapse({ screens: ['objectDetails', 'webViewAmenities'] }))
  }

  return (
    <Section
      title={
        <span className={`section-item-title`} style={{ fontSize: 'var(--size-heading-small)' }}>
          {t('wizard.screen.expandObjectDetailsCta.header')}
        </span>
      }
      subline={t('wizard.screen.expandObjectDetailsCta.subline')}
      variant='expandable'
      expanded={!isCollapsed}
      onChange={handleChange}
      className={`one-whole margin-bottom-xl ${styles.noEmptyBottomSpaceWhenExpanded}`}
    />
  )
}
